import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { ReactComponent as ArrowRightIcon } from '../../assets/icons/v2/arrow-right-thick.svg';

export const GroupsLoader = styled.div`
    width: 100%;
    height: 100vh;
`;

export const GroupWrapper = styled.div`
    width: 100%;
`;

export const NftWrapper = styled.div<{ $showEvents?: boolean }>`
    && {
        margin: 0;
        margin-top: 20px;
        padding: 0;

        width: auto;
        overflow: scroll;
        display: flex;
        width: 100%;

        scrollbar-width: none; // Firefox
        -ms-overflow-style: -ms-autohiding-scrollbar; // IE10+
        scroll-behavior: smooth;

        ::-webkit-scrollbar {
            width: 0;
            height: 0;
            background: transparent;
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            display: grid;
            grid-template-rows: auto;
            margin-top: 17px;
            overflow: auto;
        }

        ${({ $showEvents }) =>
            $showEvents
                ? css`
                      gap: 12px;

                      @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
                          gap: 20px;
                      }
                  `
                : css`
                      gap: 18px;
                  `}
    }
`;

export const NftWrapperGrid = styled.ul<{ $showThisManyItems: number; $showSmallCards?: boolean }>`
    display: grid;
    gap: 16px;
    margin: 0;
    padding: 0;
    list-style: none;

    ${({ $showThisManyItems, $showSmallCards }) => {
        if ($showSmallCards) {
            return css`
                grid-template-columns: repeat(${$showThisManyItems}, minmax(160px, 1fr));
            `;
        }
        return css`
            grid-template-columns: repeat(${$showThisManyItems}, minmax(232px, 1fr));
        `;
    }}

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: repeat(6, minmax(160px, 1fr));
        padding: 0 20px;
    }
`;

export const SeeMoreGroupCard = styled(Link)<{ $showEvents?: boolean }>`
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    justify-content: center;
    margin-right: 8px;
    padding: 10px 20px;
    width: 100%;
    min-width: 160px;
    align-self: stretch;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }

    ${({ $showEvents }) =>
        $showEvents &&
        css`
            aspect-ratio: 0.7;
            border-radius: 7px;
            margin-right: 12px;
            width: 100%;
            min-width: 160px;
        `}
`;

export const SeeMoreGroupCardHeading = styled.h3`
    font-family: 'Alliance No.1';
    color: ${({ theme }) => theme.shades.white[100]};
    font-weight: 700;
    text-align: center;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: -0.02em;
    margin: 0;
    padding: 0;
`;

export const SeeMoreGroupCardSubheading = styled.h4`
    font-family: 'Alliance No.1';
    color: ${({ theme }) => theme.shades.white[50]};
    font-weight: 400;
    text-align: center;
    font-size: 12px;
    line-height: 15.6px;
    letter-spacing: -0.02em;
    margin: 0;
    padding: 0;
`;

export const ArrowRight = styled(ArrowRightIcon)`
    width: 15px;
    filter: drop-shadow(0 0 9px rgb(255 255 255 / 0.6));
    margin-top: 8px;
`;

export const MorePodsForYou = styled.h3`
    font-family: 'Alliance No.1';
    color: #fff;
    font-weight: 700;
    text-align: center;
    margin: 0;
    margin-top: 40px;
    font-size: 28px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 50px;
        line-height: 56px;
        letter-spacing: -2px;
    }
`;

export const LoadMoreButton = styled(Button)`
    &&& {
        margin-left: 20px;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            margin-left: 0;
        }
    }
`;
